/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_KYC: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.holdersDetailPage.update.kycStatus',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_KYC' },
      },
    },
    UPDATE_KYC: {
      invoke: {
        id: 'updateKyc',
        src: 'updateKyc',
        onDone: {
          target: 'UPDATE_KYC_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_KYC_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_KYC_SUCCESS: {
      on: {
        START: { target: 'UPDATE_KYC' },
      },
    },
    UPDATE_KYC_FAILED: {
      on: {
        START: { target: 'UPDATE_KYC' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
